var req = require.context("./plugins", true, /^(.*\.(js$))[^.]*$/igm);
var req2 = require.context("./scripts", true, /^(.*\.(js$))[^.]*$/igm);

req.keys().forEach(function(key){
    req(key);
});

req2.keys().forEach(function(key){
    req2(key);
});


//////////////////
// WEBPACK FOOTER
// ./js/components/modules.js
// module id = 0
// module chunks = 0